var $a97fefa2956f4bcb$exports = {};
$a97fefa2956f4bcb$exports = {
  "dragDescriptionKeyboard": "\uB4DC\uB798\uADF8\uB97C \uC2DC\uC791\uD558\uB824\uBA74 Enter\uB97C \uB204\uB974\uC138\uC694.",
  "dragDescriptionKeyboardAlt": "\uB4DC\uB798\uADF8\uB97C \uC2DC\uC791\uD558\uB824\uBA74 Alt + Enter\uB97C \uB204\uB974\uC2ED\uC2DC\uC624.",
  "dragDescriptionLongPress": "\uB4DC\uB798\uADF8\uB97C \uC2DC\uC791\uD558\uB824\uBA74 \uAE38\uAC8C \uB204\uB974\uC2ED\uC2DC\uC624.",
  "dragDescriptionTouch": "\uB4DC\uB798\uADF8\uB97C \uC2DC\uC791\uD558\uB824\uBA74 \uB354\uBE14 \uD0ED\uD558\uC138\uC694.",
  "dragDescriptionVirtual": "\uB4DC\uB798\uADF8\uB97C \uC2DC\uC791\uD558\uB824\uBA74 \uD074\uB9AD\uD558\uC138\uC694.",
  "dragItem": function dragItem(args) {
    return "".concat(args.itemText, " \uB4DC\uB798\uADF8");
  },
  "dragSelectedItems": function dragSelectedItems(args, formatter) {
    return "".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), "\uAC1C \uC120\uD0DD \uD56D\uBAA9");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), "\uAC1C \uC120\uD0DD \uD56D\uBAA9");
      }
    }), " \uB4DC\uB798\uADF8");
  },
  "dragSelectedKeyboard": function dragSelectedKeyboard(args, formatter) {
    return "".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), "\uAC1C \uC120\uD0DD \uD56D\uBAA9");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), "\uAC1C \uC120\uD0DD \uD56D\uBAA9");
      }
    }), "\uC744 \uB4DC\uB798\uADF8\uD558\uB824\uBA74 Enter\uB97C \uB204\uB974\uC2ED\uC2DC\uC624.");
  },
  "dragSelectedKeyboardAlt": function dragSelectedKeyboardAlt(args, formatter) {
    return "".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), "\uAC1C \uC120\uD0DD \uD56D\uBAA9");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), "\uAC1C \uC120\uD0DD \uD56D\uBAA9");
      }
    }), "\uC744 \uB4DC\uB798\uADF8\uD558\uB824\uBA74 Alt + Enter\uB97C \uB204\uB974\uC2ED\uC2DC\uC624.");
  },
  "dragSelectedLongPress": function dragSelectedLongPress(args, formatter) {
    return "".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), "\uAC1C \uC120\uD0DD \uD56D\uBAA9");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), "\uAC1C \uC120\uD0DD \uD56D\uBAA9");
      }
    }), "\uC744 \uB4DC\uB798\uADF8\uD558\uB824\uBA74 \uAE38\uAC8C \uB204\uB974\uC2ED\uC2DC\uC624.");
  },
  "dragStartedKeyboard": "\uB4DC\uB798\uADF8\uAC00 \uC2DC\uC791\uB418\uC5C8\uC2B5\uB2C8\uB2E4. Tab\uC744 \uB20C\uB7EC \uB4DC\uB86D \uB300\uC0C1\uC73C\uB85C \uC774\uB3D9\uD55C \uB2E4\uC74C Enter\uB97C \uB20C\uB7EC \uB4DC\uB86D\uD558\uAC70\uB098 Esc\uB97C \uB20C\uB7EC \uCDE8\uC18C\uD558\uC138\uC694.",
  "dragStartedTouch": "\uB4DC\uB798\uADF8\uAC00 \uC2DC\uC791\uB418\uC5C8\uC2B5\uB2C8\uB2E4. \uB4DC\uB86D \uB300\uC0C1\uC73C\uB85C \uC774\uB3D9\uD55C \uB2E4\uC74C \uB354\uBE14 \uD0ED\uD558\uC5EC \uB4DC\uB86D\uD558\uC138\uC694.",
  "dragStartedVirtual": "\uB4DC\uB798\uADF8\uAC00 \uC2DC\uC791\uB418\uC5C8\uC2B5\uB2C8\uB2E4. \uB4DC\uB86D \uB300\uC0C1\uC73C\uB85C \uC774\uB3D9\uD55C \uB2E4\uC74C \uD074\uB9AD\uD558\uAC70\uB098 Enter\uB97C \uB20C\uB7EC \uB4DC\uB86D\uD558\uC138\uC694.",
  "dropCanceled": "\uB4DC\uB86D\uC774 \uCDE8\uC18C\uB418\uC5C8\uC2B5\uB2C8\uB2E4.",
  "dropComplete": "\uB4DC\uB86D\uC774 \uC644\uB8CC\uB418\uC5C8\uC2B5\uB2C8\uB2E4.",
  "dropDescriptionKeyboard": "\uB4DC\uB86D\uD558\uB824\uBA74 Enter\uB97C \uB204\uB974\uC138\uC694. \uB4DC\uB798\uADF8\uB97C \uCDE8\uC18C\uD558\uB824\uBA74 Esc\uB97C \uB204\uB974\uC138\uC694.",
  "dropDescriptionTouch": "\uB354\uBE14 \uD0ED\uD558\uC5EC \uB4DC\uB86D\uD558\uC138\uC694.",
  "dropDescriptionVirtual": "\uB4DC\uB86D\uD558\uB824\uBA74 \uD074\uB9AD\uD558\uC138\uC694.",
  "dropIndicator": "\uB4DC\uB86D \uD45C\uC2DC\uAE30",
  "dropOnItem": function dropOnItem(args) {
    return "".concat(args.itemText, "\uC5D0 \uB4DC\uB86D");
  },
  "dropOnRoot": "\uB4DC\uB86D \uB300\uC0C1",
  "endDragKeyboard": "\uB4DC\uB798\uADF8 \uC911\uC785\uB2C8\uB2E4. \uB4DC\uB798\uADF8\uB97C \uCDE8\uC18C\uD558\uB824\uBA74 Enter\uB97C \uB204\uB974\uC138\uC694.",
  "endDragTouch": "\uB4DC\uB798\uADF8 \uC911\uC785\uB2C8\uB2E4. \uB4DC\uB798\uADF8\uB97C \uCDE8\uC18C\uD558\uB824\uBA74 \uB354\uBE14 \uD0ED\uD558\uC138\uC694.",
  "endDragVirtual": "\uB4DC\uB798\uADF8 \uC911\uC785\uB2C8\uB2E4. \uB4DC\uB798\uADF8\uB97C \uCDE8\uC18C\uD558\uB824\uBA74 \uD074\uB9AD\uD558\uC138\uC694.",
  "insertAfter": function insertAfter(args) {
    return "".concat(args.itemText, " \uC774\uD6C4\uC5D0 \uC0BD\uC785");
  },
  "insertBefore": function insertBefore(args) {
    return "".concat(args.itemText, " \uC774\uC804\uC5D0 \uC0BD\uC785");
  },
  "insertBetween": function insertBetween(args) {
    return "".concat(args.beforeItemText, " \uBC0F ").concat(args.afterItemText, " \uC0AC\uC774\uC5D0 \uC0BD\uC785");
  }
};
export { $a97fefa2956f4bcb$exports as default };